import request from './core/request'

// 求购询价相关API
export default {
	//发布求购
	publish: (data) => request.post('/wanted/publish', data, {}),
	//获取我的求购列表
	getWantedList: (params) => request.get('/wanted/my-list', params, {}),
	//获取求购状态列表
	getStatusList: (params) => request.get('/wanted/status-list', params, {}),
	//撤回求购（删除）
	deleteWanted: (id) => request.delete(`/wanted/${id}`, {}, {}),
	//获取求购的商家报价列表
	getQuotesList: (params, wantedId) => request.get(`/wanted/${wantedId}/quotes`, params, {}),
}